// client/src/views/Interactive_parts/viewUtils.js
export function createViewHandlers({
  setColourLocked,
  setResetTrigger,
}) {
  function handleUnlockColour() {
    setColourLocked(false);
  }

  function handleResetView() {
    setResetTrigger(t => t + 1);
  }

  return {
    handleUnlockColour,
    handleResetView,
  };
}
